module.exports = __webpack_public_path__ + "img/youtube-icon.ada9f4b5.svg";